import { render } from "./change-password-msg-box.vue?vue&type=template&id=5de7f7b2&scoped=true&ts=true"
import script from "./change-password-msg-box.vue?vue&type=script&lang=ts"
export * from "./change-password-msg-box.vue?vue&type=script&lang=ts"

import "./change-password-msg-box.vue?vue&type=style&index=0&id=5de7f7b2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de7f7b2"]])

export default __exports__